import { defineStore } from 'pinia'
import api from '@/api'

let addressData = localStorage.getItem('addressData')
addressData = addressData ? JSON.parse(addressData) : []
let menuPromise = null
const HsystemStore = defineStore('Hsystem', {
  state: () => {
    return {
      deviceId: '', // 设备id
      homeData: [],
      homeDataFetchedAt: 0, // 首页配置最后成功拉取时间戳（TTL 节流用）
      breadcrumbList: [], //分类列表
      menuData: [], // 目录tab
      addressData: addressData // 城市地址源数据
    }
  },
  actions: {
    // 获取目录
    getMenuDataList() {
      if (this.menuData.length) return Promise.resolve(this.menuData)
      if (menuPromise) return menuPromise
      menuPromise = api.product
        .getCategories({
          'executed.equals': true
        })
        .then((res) => {
          if (res && res.length) {
            this.menuData = res.length === 1 ? res[0].children : res
            console.log(this.menuData, 'menuData')
          }
          return this.menuData
        })
        .catch((error) => {
          console.log('重复接口请求已拒绝', error) // 打印完整捕获的错误
          return this.menuData
        })
        .finally(() => {
          menuPromise = null
        })
      return menuPromise
    },
    // 分类列表
    setBreadcrumbList(data) {
      console.log(data, 'setBreadcrumbList')
      this.breadcrumbList = data
    },
    // 获取目录
    setHomeData(data) {
      this.homeData = data
      this.homeDataFetchedAt = Date.now()
    },
    // 账户变更（登出 / 登录 / 换号 / 401 掉线）：作废首页配置缓存，下次进首页必重拉。
    // collected 由服务端下发，前端不持有任何领取标记，故这里只需作废配置。
    clearHomeData() {
      this.homeData = []
      this.homeDataFetchedAt = 0
    },
    setAddressData(data) {
      this.addressData = data
    },
    setDeviceId(id) {
      this.deviceId = id
    }
  }
})

export default HsystemStore
